/**
 * Takes a value of type `never` and throws an error if called. Used to ensure
 * exhaustiveness checking in switch/if statements at compile time. The function
 * will fail to compile if passed any type other than `never`, ensuring all cases
 * have been handled.
 *
 * @param _ - A value that must be of type `never` for the code to compile
 * @throws {Error} Always throws if executed, indicating a case was missed
 *
 * @example
 * ```typescript
 * enum Color { Red, Blue }
 *
 * function handleColor(color: Color) {
 *   switch (color) {
 *     case Color.Red:
 *       return "It's red";
 *     case Color.Blue:
 *       return "It's blue";
 *     default:
 *       assertNever(color); // Will fail to compile if new values are added to Color
 *   }
 * }
 * ```
 */
export const assertNever = (_: never): never => {
  throw new Error(`Unhandled case: ${String(_)}`);
};
